// This doesn't cover all subTypes
export const subTypes = {
    controlService: 7
};

// This holdes subTypes which changing it's control should be disabled
export const disabledSubTypes = [subTypes.controlService];